// extracted by mini-css-extract-plugin
var _1 = "webpack-system-base-Dialog-module__closeButton";
var _2 = "webpack-system-base-Dialog-module__content";
var _3 = "webpack-system-base-Dialog-module__header";
var _4 = "webpack-system-base-Dialog-module__title";
export { _1 as "closeButton", _2 as "content", _3 as "header", _4 as "title" }
